<template lang="pug">
button.transparent-button.custom-check-box.d-flex.align-items-center.py-1(
  @click='isChecked = !isChecked'
)
  .check-container(:class="{'is-active': isChecked}")
    .check
  .ml-3
    slot

</template>

<script>
export default {
  props: {
    value: {},
  },
  watch: {
    value() {
      this.isChecked = this.value;
    },
    isChecked() {
      this.$emit('input', this.isChecked);
    },
  },
  mounted() {
    this.isChecked = this.value;
  },
  data: () => ({
    isChecked: false,
  }),
};
</script>

<style lang="scss">
// .custom-check-box {}
</style>
